
export const PromiseErrorHandler = function(err) {
    console.log(['PromiseErrorHandler', err]);
    return  err;
};

export const EP2 = {};

// module.exports = {PromiseErrorHandler, EP2};
